module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/qris_official-2bbce80a46668885eb897375a55c815f.svg";